export default function AboutRankings() {
    return (
        <>
            <p>
                Podtrac measures thousands of shows including the top shows from large publishers as
                well as smaller shows. The <i>Rankings</i> tabs on your dashboard provide insight
                into how your shows rank against all Podtrac measured shows.
            </p>

            <p>
                The Account-level <i>Rankings</i> tab allows you to see at a glance how each show in
                your account ranks among Podtrac measured shows and against one another by month.
                The Show-level <i>Rankings</i> tab provides historical ranking data for each of your
                shows.
            </p>

            <p>
                Both Account-level and Show-level rankings are available at the US and Global
                levels, which you can select using the Global/USA drop down at the upper right of
                your screen. You can also view how each of your shows ranks within its main category
                by using the Overall/Category drop down at the upper right of the screen.
            </p>

            <p>
                Rankings are monthly and are provided for both Unique Monthly Audience (UMA) and
                Monthly Downloads along with an indication of how the rank has changed from last
                month. For each metric the percentile is given which allows you to understand how
                your rank fits into the larger picture of all shows.
            </p>
        </>
    );
}
